import React from 'react';
// import { BrowserRouter, Routes, Route, Link, useNavigate } from 'react-router-dom';

const Dashboard = () => {
 

    return (
        <div className="p-4">
            <h1 className="text-2xl font-bold mb-4">Admin Dashboard</h1>
   
        </div>
    );
}

export default Dashboard;
